import React, { useState, useEffect, useContext } from 'react';
import { useSiteData } from 'react-static';
import { ThemeContext } from 'styled-components';
// template components
import SectionVideoPlayer from '@nmx/template/dist/componentLibrary/modules/SectionVideoPlayer';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import backgroundImageDesktop from './images/couple-playing-basketball-desktop.webp';
import backgroundImageMobile from './images/couple-playing-basketball-mobile.webp';

export default () => {
  const { config } = useSiteData();

  const theme = useContext(ThemeContext);
  const mediumDown = theme.mediumDown();
  const [isMediumDown, setIsMediumDown] = useState(mediumDown);

  const thisTitle = <>Protect your assets with long&#45;term <WidowBlock>care planning.</WidowBlock></>;

  useEffect(() => {
    if (mediumDown !== isMediumDown) {
      setIsMediumDown(mediumDown);
    }
  }, [mediumDown, isMediumDown]);

  return (
    <SectionVideoPlayer
      backgroundImage={isMediumDown ? backgroundImageMobile : backgroundImageDesktop}
      config={config}
      playButtonSupportiveText='Watch the video'
      duration='1m 41s'
      durationDisplay='2 min' // round to nearest minute from duration
      sectionId='protect-assets-with-ltc-planning'
      videoId='6N14Qtv2y_g'
      videoTitle={thisTitle}
      title={thisTitle}
    />
  );
};

